<div class="flex items-center gap-2" [style.direction]="dir">
  <div *ngIf="label">
    <label [attr.for]="inputId" class="block text-gray-500 w-[100%] text-sm">{{ label }}</label>
  </div>
  <div class="flex items-center relative">
    <svg class="absolute top-1/2 -translate-y-1/2 w-4 h-4 text-primary" width="20" height="20"
      [ngClass]="{ 'left-0': dir === 'ltr', 'right-0': dir === 'rtl' }"
      [style.left]="dir === 'ltr' ? '.625rem' : 'auto'"
      [style.right]="dir === 'rtl' ? '.625rem' : 'auto'"
      viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
    <input
      #dateRangeInput
      [id]="inputId"
      type="text"
      ngxDaterangepickerMd
      [(ngModel)]="selected"
      [ngModelOptions]="{ standalone: true }"
      [name]="inputId + 'Daterange'"
      [ranges]="ranges"
      [showRangeLabelOnInput]="true"
      [showCustomRangeLabel]="true"
      [locale]="locale"
      [alwaysShowCalendars]="false"
      [linkedCalendars]="true"
      [showClearButton]="false"
      [autoApply]="true"
      [closeOnAutoApply]="true"
      [keepCalendarOpeningWithRange]="true"
      [drops]="'down'"
      [opens]="opens"
      (datesUpdated)="onApply($event)"
      (clearClicked)="onClear()"
      [class]="inputClass"
      [style.cursor]="'default'"
      [placeholder]="placeholder"
    />
    <span class="absolute inset-y-0 right-2 flex items-center text-gray-500"
      (click)="openPicker(dateRangeInput)"
      [ngClass]="{ 'right-2': dir === 'ltr', 'left-2': dir === 'rtl' }">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </span>
  </div>
</div>
